<template>
	<div :class="containerClass">
		<div class="topbar">
			<CollectorAppTopbar
:topbar-menu-active="topbarMenuActive" :active-topbar-item="activeTopbarItem"
				:inline-user="inlineUser" @right-menubutton-click="onRightMenuButtonClick" @backbutton-click="onBackButtonClick"
				@topbar-menubutton-click="onTopbarMenuButtonClick" @topbar-item-click="onTopbarItemClick" />
		</div>

		<!-- <AppRightMenu :rightPanelMenuActive="rightPanelMenuActive" @rightmenu-click="onRightMenuClick"></AppRightMenu> -->

		<transition name="layout-menu-container">
			<div v-show="isMenuVisible()" class="layout-menu-container" @click="onMenuClick">
				<div class="menu-scroll-content">
					<div v-if="inlineUser" class="layout-profile">
						<button class="p-link layout-profile-button" @click="onInlineUserClick">
							<img src="~/assets/images/avatar.jpg" alt="roma-layout">
							<span class="layout-profile-userinfo">
								<span class="layout-profile-name">Arlene Welch</span>
								<span class="layout-profile-role">Design Ops</span>
							</span>
						</button>
						<transition name="layout-profile-menu">
							<ul
v-show="inlineUserMenuActive" class="layout-profile-menu"
								:class="[{ 'profile-menu-active': inlineUserMenuActive }]">
								<li>
									<button class="p-link">
										<i class="pi pi-fw pi-user" /><span>Profile</span>
									</button>
								</li>
								<li>
									<button class="p-link">
										<i class="pi pi-fw pi-cog" /><span>Settings</span>
									</button>
								</li>
								<li>
									<button class="p-link">
										<i class="pi pi-fw pi-envelope" /><span>Messages</span>
									</button>
								</li>
								<li>
									<button class="p-link">
										<i class="pi pi-fw pi-bell" /><span>Notifications</span>
									</button>
								</li>
							</ul>
						</transition>
					</div>
					<AppMenu :model="pageStore.isCollector() === true ? menuCollector : menuStation" :layout-mode="layoutMode"
						:active="menuActive" :mobile-menu-active="staticMenuMobileActive" @menuitem-click="onMenuItemClick"
						@root-menuitem-click="onRootMenuItemClick" />
				</div>
			</div>
		</transition>

		<div class="layout-main">
			<div class="layout-content">
				<slot />
			</div>
		</div>

		<div class="layout-content-mask" />
	</div>
</template>

<script lang="ts" setup>
	// import { useToast } from 'primevue/usetoast';
	// import { usePrimeVue } from "primevue/config";
	import { computed, ref, watch } from "vue";
	import { storeToRefs } from "pinia";
	import { menuCollector, menuStation } from "@/data";
	import useScrollTopBar from "~/composables/style/useScrollTopBar";

	useScrollTopBar();
	// stores
	const pageStore = usePageStore();
	const allowedMenusStore = useAllowedMenus();
	const { layout } = storeToRefs(pageStore);
	const router = useRouter();

	const route = ref(router);
	const isLoading = ref(true);

	const toast = useToast();
	const primeVue = usePrimeVue();
	const { $eventBus } = useNuxtApp();

	const layoutMode = ref<string | undefined>("static");
	const lightMenu = ref<boolean | null>(true);
	const overlayMenuActive = ref(false);
	const staticMenuMobileActive = ref(false);
	const staticMenuDesktopInactive = ref(false);
	const isRTL = ref<boolean | null>(false);
	const inlineUser = ref<boolean | null>(false);
	const topbarMenuActive = ref(false);
	const activeTopbarItem = ref<string>("null");
	const rightPanelMenuActive = ref(false);
	const inlineUserMenuActive = ref(false);
	const menuActive = ref(false);
	const topbarColor = ref<string | null>("layout-topbar-blue");
	const topbarItemClick = ref(false);
	const rightMenuClick = ref(false);
	const userMenuClick = ref(false);
	const menuClick = ref(false);
	const theme = ref<string>("blue");

	onMounted(() => {
		pageStore.showSearchBar = false;
	});

	const topbarColors: unknown[] | null = [
		{ name: "Light", topbarColor: "layout-topbar-light", logo: "logo-roma", color: "#ffffff" },
		{ name: "Dark", topbarColor: "layout-topbar-dark", logo: "logo-roma-white", color: "#252529" },
		{ name: "Blue", topbarColor: "layout-topbar-blue", logo: "logo-roma-white", color: "#0772B3" },
		{ name: "Green", topbarColor: "layout-topbar-green", logo: "logo-roma-white", color: "#0F8C50" },
		{ name: "Orange", topbarColor: "layout-topbar-orange", logo: "logo-roma-white", color: "#C76D09" },
		{
			name: "Magenta",
			topbarColor: "layout-topbar-magenta",
			logo: "logo-roma-white",
			color: "#972BB1"
		},
		{
			name: "Blue Grey",
			topbarColor: "layout-topbar-bluegrey",
			logo: "logo-roma-white",
			color: "#406E7E"
		},
		{
			name: "Deep Purple",
			topbarColor: "layout-topbar-deeppurple",
			logo: "logo-roma-white",
			color: "#543CD9"
		},
		{ name: "Brown", topbarColor: "layout-topbar-brown", logo: "logo-roma-white", color: "#794F36" },
		{ name: "Lime", topbarColor: "layout-topbar-lime", logo: "logo-roma-white", color: "#849201" },
		{ name: "Rose", topbarColor: "layout-topbar-rose", logo: "logo-roma-white", color: "#8F3939" },
		{ name: "Cyan", topbarColor: "layout-topbar-cyan", logo: "logo-roma-white", color: "#0C8990" },
		{ name: "Teal", topbarColor: "layout-topbar-teal", logo: "logo-roma-white", color: "#337E59" },
		{
			name: "Deep Orange",
			topbarColor: "layout-topbar-deeporange",
			logo: "logo-roma-white",
			color: "#D74A1D"
		},
		{ name: "Indigo", topbarColor: "layout-topbar-indigo", logo: "logo-roma-white", color: "#3D53C9" },
		{ name: "Pink", topbarColor: "layout-topbar-pink", logo: "logo-roma-white", color: "#BF275B" },
		{ name: "Purple", topbarColor: "layout-topbar-purple", logo: "logo-roma-white", color: "#7F32DA" },
	];

	const themeColors: { name: string; file: string; color: string }[] | null = [
		{ name: "Blue", file: "blue", color: "#0f97c7" },
		{ name: "Blue Grey", file: "bluegrey", color: "#578697" },
		{ name: "Brown", file: "brown", color: "#97664A" },
		{ name: "Cyan", file: "cyan", color: "#1BA7AF" },
		{ name: "Deep Orange", file: "deeporange", color: "#F96F43" },
		{ name: "Deep Purple", file: "deeppurple", color: "#6952EC" },
		{ name: "Green", file: "green", color: "#10B163" },
		{ name: "Teal", file: "teal", color: "#4EA279" },
		{ name: "Indigo", file: "indigo", color: "#435AD8" },
		{ name: "Lime", file: "lime", color: "#A5B600" },
		{ name: "Magenta", file: "magenta", color: "#B944D6" },
		{ name: "Orange", file: "orange", color: "#E2841A" },
		{ name: "Pink", file: "pink", color: "#E93A76" },
		{ name: "Purple", file: "purple", color: "#9643F9" },
		{ name: "Rose", file: "rose", color: "#AB5353" },
	];

	watch(route, () => {
		menuActive.value = false;
		toast.removeAllGroups();
	});

	// watch(pageStore, (received) => {
	//   if (received) {
	//     definePageMeta({
	//       layout: "default"
	//     })
	//     isLoading.value = false
	//   }
	// })

	// function redirectToLoginIfNotAuthenticated() {
	//   const cookie = useCookie('accessToken').value
	//   //if (!cookie) {
	//   // navigateTo("/login")
	//   //}

	//   if (cookie) {
	//     pageStore.setLayout("main")
	//   }
	// }

	function onDocumentClick() {
		if (!topbarItemClick.value) {
			activeTopbarItem.value = "null";
			topbarMenuActive.value = false;
		}
		if (!rightMenuClick.value)
			rightPanelMenuActive.value = false;

		if (!userMenuClick.value && isSlim() && !isMobile())
			inlineUserMenuActive.value = false;

		if (!menuClick.value) {
			if (isHorizontal() || isSlim())
				menuActive.value = false;

			if (overlayMenuActive.value || staticMenuMobileActive)
				hideOverlayMenu();

			useEventBus("reset-active-index").emit();
			unblockBodyScroll();
		}
		if (userMenuClick.value) {
			menuActive.value = false;
			useEventBus("reset-active-index").emit();
		}

		topbarItemClick.value = false;
		menuClick.value = false;
		rightMenuClick.value = false;
		userMenuClick.value = false;
	}

	function onBackButtonClick(event: Event) {
		router.back();
	}
	function onTopbarMenuButtonClick(event: Event) {
		topbarItemClick.value = true;
		topbarMenuActive.value = !topbarMenuActive.value;
		hideOverlayMenu();
		event.preventDefault();
	}
	function onTopbarItemClick(event: { originalEvent: Event; item: string }) {
		topbarItemClick.value = true;
		if (activeTopbarItem.value === event.item)
			activeTopbarItem.value = "null";
		else activeTopbarItem.value = event.item;
		event.originalEvent.preventDefault();
	}

	function onMenuClick() {
		menuClick.value = true;
	}
	function onInlineUserClick() {
		userMenuClick.value = true;
		inlineUserMenuActive.value = !inlineUserMenuActive.value;
	}
	function blockBodyScroll() {
		addClass(document.body, "blocked-scroll");
	}
	function unblockBodyScroll() {
		removeClass(document.body, "blocked-scroll");
	}
	function onRightMenuButtonClick(event: unknown) {
		rightMenuClick.value = true;
		rightPanelMenuActive.value = !rightPanelMenuActive.value;
		hideOverlayMenu();
		event.preventDefault();
	}
	function onRightMenuClick() {
		rightMenuClick.value = true;
	}
	function hideOverlayMenu() {
		overlayMenuActive.value = false;
		staticMenuMobileActive.value = false;
	}

	function onMenuItemClick(event: unknown) {
		if (!event.item.items) {
			$eventBus.$emit("reset-active-index");
			hideOverlayMenu();
		}
		if (!event.item.items && (isHorizontal() || isSlim()))
			menuActive.value = false;
	}
	function onRootMenuItemClick() {
		menuActive.value = !menuActive.value;
	}
	/* function isTablet() {
			if(process.client){
			let width = window.innerWidth;
			return width <= 1024 && width > 640;
			}
		} */
	function isDesktop() {
		if (import.meta.client)
			return window.innerWidth > 896;
	}
	function isMobile() {
		if (import.meta.client)
			return window.innerWidth <= 1025;
	}
	function isHorizontal() {
		return layoutMode.value === "horizontal";
	}
	function isSlim() {
		return layoutMode.value === "slim";
	}
	function isMenuVisible() {
		if (isDesktop()) {
			if (layoutMode.value === "static")
				return !staticMenuDesktopInactive.value;
			else if (layoutMode.value === "overlay")
				return overlayMenuActive.value;
			else return true;
		}
		else {
			return true;
		}
	}
	function onLayoutChange(p_layoutMode: unknown) {
		layoutMode.value = p_layoutMode;
		staticMenuDesktopInactive.value = false;
		overlayMenuActive.value = false;
		if (isSlim() || isHorizontal()) {
			inlineUser.value = false;
			inlineUserMenuActive.value = false;
		}
	}
	function onMenuColorChange(menuColor: unknown) {
		lightMenu.value = menuColor;
	}
	function onProfileModeChange(profileMode: unknown) {
		inlineUser.value = profileMode;
	}
	function onChangeOrientation(orientation: unknown) {
		isRTL.value = orientation;
	}
	function onTopbarColorChange(p_topbarColor: unknown, logo: unknown) {
		topbarColor.value = p_topbarColor;
		const topbarLogoLink: unknown = document.getElementById("topbar-logo");
		topbarLogoLink.src = `../assets/images/${logo}.svg`;
	}

	/**
	 * TROCA DE TEMA DESABILITADA PARA PERFORMANCE
	 * Apenas theme-blue está carregado no sistema
	 */

	// function onThemeChange(p_theme: string) {
	// 	theme.value = p_theme;
	// 	changeStyleSheetUrl("layout-css", theme.value, "layout");
	// 	changeStyleSheetUrl("theme-css", theme.value, "theme");
	// }
	// function changeStyleSheetUrl(id: string, value: string, prefix: string) {
	// 	const element: unknown = document.getElementById(id);
	// 	const urlTokens = element.getAttribute("href").split("/");
	// 	urlTokens[urlTokens.length - 1] = `${prefix}-${value}.css`;
	// 	const newURL = urlTokens.join("/");
	// 	replaceLink(element, newURL);
	// }
	// function replaceLink(linkElement: unknown, href: unknown) {
	// 	const id = linkElement.getAttribute("id");
	// 	const cloneLinkElement = linkElement.cloneNode(true);
	// 	cloneLinkElement.setAttribute("href", href);
	// 	cloneLinkElement.setAttribute("id", `${id}-clone`);
	// 	linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);
	// 	cloneLinkElement.addEventListener("load", () => {
	// 		linkElement.remove();
	// 		cloneLinkElement.setAttribute("id", id);
	// 	});
	// }

	function addClass(element: unknown, className: string) {
		if (element.classList)
			element.classList.add(className);
		else element.className += ` ${className}`;
	}
	function removeClass(element: unknown, className: string) {
		if (element.classList)
			element.classList.remove(className);
		else element.className = element.className.replace(new RegExp(`(^|\\b)${className.split(" ").join("|")}(\\b|$)`, "gi"), " ");
	}
	const containerClass = computed(() => [
		"layout-wrapper",
		{
			"layout-horizontal": layoutMode.value === "horizontal",
			"layout-overlay": layoutMode.value === "overlay",
			"layout-static": layoutMode.value === "static",
			"layout-slim": layoutMode.value === "slim",
			"layout-menu-light": lightMenu.value === true,
			"layout-menu-dark": lightMenu.value === false,
			"layout-overlay-active": overlayMenuActive.value,
			"layout-mobile-active": staticMenuMobileActive.value,
			"layout-static-inactive": staticMenuDesktopInactive.value,
			"layout-rtl": isRTL.value,
			"p-input-filled": primeVue.config.inputStyle === "filled",
			"p-ripple-disabled": primeVue.config.ripple === false,
		},
		topbarColor.value,
	]);
</script>

<style lang="scss" scoped>
	.layout-main {

		padding-top: 0px !important;

		.layout-content {
			padding: 0px !important;
		}
	}

	@media screen and (max-width: 896px) {
		.layout-wrapper .layout-main {
			margin-left: 0;
			padding-top: calc(20%);
			transition: margin-left 0.2s;
		}
	}

	@media screen and (max-width: 240px) {
		.layout-content {
			padding: 5px !important;
		}
	}

	.Footer {
		padding: 16px;

	}

	.topbar {
		height: calc(10%);
	}
</style>
